/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Pole_Dance_TermsInputs */

const en_service_type_pole_dance_terms = /** @type {(inputs: Service_Type_Pole_Dance_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pole dance, pole fitness`)
};

const pl_service_type_pole_dance_terms = /** @type {(inputs: Service_Type_Pole_Dance_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pole dance, taniec na rurze, pole sport`)
};

/**
* | output |
* | --- |
* | "pole dance, pole fitness" |
*
* @param {Service_Type_Pole_Dance_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_pole_dance_terms = /** @type {((inputs?: Service_Type_Pole_Dance_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Pole_Dance_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_pole_dance_terms(inputs)
	return en_service_type_pole_dance_terms(inputs)
});